import { useEffect, useState, useContext } from 'react'
import { WalletContext } from '../../components/WalletContext'
import { Address } from '@ton/core'
import NFTCard from '../../components/NFTCard'
import './MyNFTs.css'

export default function MyNFTs() {
	const { walletAddress } = useContext(WalletContext)
	const [nfts, setNfts] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		if (!walletAddress) return

		const fetchNFTs = async () => {
			setLoading(true)

			try {
				const convertedWallet = Address.parse(walletAddress).toString({
					bounceable: false,
				})

				const res = await fetch('https://api.testnet.getgems.io/graphql', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-gg-client': 'v:1 l:en',
						Referer: 'https://testnet.getgems.io/',
					},
					body: JSON.stringify({
						operationName: 'nftSearch',
						variables: {
							query: JSON.stringify({
								$and: [
									{
										ownerAddress: convertedWallet, 
									},
								],
							}),
							attributes: null,
							sort: JSON.stringify([
								{ isOnSale: { order: 'desc' } },
								{ price: { order: 'asc' } },
								{ index: { order: 'asc' } },
							]),
							count: 50,
						},
						extensions: {
							persistedQuery: {
								version: 1,
								sha256Hash:
									'c9c9eab431a93e6129d91b717415c30dff830bfd09e2f99ffa97d2ebc02ac971',
							},
						},
					}),
				})

				const json = await res.json()
				console.log('📦 FULL API RESPONSE:', json)

				const edges = json?.data?.alphaNftItemSearch?.edges || []

				const filtered = edges.map(({ node }) => {
					const content = node?.content || {}
					const image =
						typeof content.image?.baseUrl === 'string'
							? content.image.baseUrl
							: null

					return {
						name: content.name || node.name || 'Untitled',
						image,
						address: node.address,
						collection: node.collection,
						collectionName: node?.collection?.name || 'Unnamed Collection',
						owner: node?.owner?.wallet,
					}
				})

				setNfts(filtered)
			} catch (err) {
				console.error('❌ Error fetching NFTs:', err)
				setNfts([])
			} finally {
				setLoading(false)
			}
		}

		fetchNFTs()
	}, [walletAddress])

	return (
		<>
			{!walletAddress && (
				<div className='preview-box'>
					<p className='preview-label' style={{ color: '#ff4444' }}>
						🚫 Please connect your wallet to view your NFTs
					</p>
				</div>
			)}

			{walletAddress && (
				<div className='nft-gallery'>
					<h1>Your NFT Collection</h1>
					{loading ? (
						<p className='preview-label'>Loading your NFTs...</p>
					) : nfts.length === 0 ? (
						<p className='preview-label'>You don’t own any NFTs.</p>
					) : (
						<div className='nft-grid'>
							{nfts.map(nft => (
								<NFTCard key={nft.address} nft={nft} />
							))}
						</div>
					)}
				</div>
			)}
		</>
	)
}
